<template>
    <div class="container-fluid mt-2 mb-5">
        <!-- Modal para crear/editar contacto -->
        <vs-dialog prevent-close not-center v-model="modalContact">
            <template #header>
                <h4 class="not-margin">{{ isEditing ? 'Edit' : 'Create' }} <b>contact</b></h4>
            </template>
                         <div class="con-content">
                 <p class="text-muted small mb-3">
                     <span class="text-danger">*</span> Required fields
                 </p>
                 <div class="form-group">
                                         <p class="smallText">
                         Contact Name: <span class="text-danger">*</span>
                         <input class="form-control" type="text" v-model="contactForm.contact_name" placeholder="John Doe" />
                     </p>
                     <p class="smallText">
                         Phone: <span class="text-danger">*</span>
                         <input class="form-control" type="tel" v-model="contactForm.phone" v-mask="'###-###-####'" placeholder="555-123-4567" />
                     </p>
                    <p class="smallText">
                        Email:
                        <input class="form-control" type="email" v-model="contactForm.email" placeholder="john@example.com" />
                    </p>
                    <p class="smallText">
                        Street Address:
                        <input class="form-control" type="text" v-model="contactForm.street" placeholder="123 Main St" />
                    </p>
                    <div class="row">
                        <div class="col-md-6">
                            <p class="smallText">
                                City:
                                <input class="form-control" type="text" v-model="contactForm.city" placeholder="New York" />
                            </p>
                        </div>
                                                 <div class="col-md-6">
                             <p class="smallText">
                                 State:
                                 <select class="form-control" v-model="contactForm.state" :disabled="contactForm.country !== 'United States'">
                                     <option value="">Select State</option>
                                     <option v-for="state in usStates" :key="state.code" :value="state.code">
                                         {{ state.code }} - {{ state.name }}
                                     </option>
                                 </select>
                             </p>
                         </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <p class="smallText">
                                ZIP Code:
                                <input class="form-control" type="text" v-model="contactForm.zip_code" placeholder="10001" />
                            </p>
                        </div>
                        <div class="col-md-6">
                            <p class="smallText">
                                Country:
                                <select class="form-control" v-model="contactForm.country">
                                    <option value="United States">United States</option>
                                    <option value="Canada">Canada</option>
                                    <option value="Mexico">Mexico</option>
                                    <option value="United Kingdom">United Kingdom</option>
                                    <option value="Germany">Germany</option>
                                    <option value="France">France</option>
                                    <option value="Spain">Spain</option>
                                    <option value="Italy">Italy</option>
                                    <option value="Australia">Australia</option>
                                    <option value="Brazil">Brazil</option>
                                    <option value="Argentina">Argentina</option>
                                    <option value="Chile">Chile</option>
                                    <option value="Colombia">Colombia</option>
                                    <option value="Peru">Peru</option>
                                    <option value="Venezuela">Venezuela</option>
                                    <option value="Ecuador">Ecuador</option>
                                    <option value="Bolivia">Bolivia</option>
                                    <option value="Paraguay">Paraguay</option>
                                    <option value="Uruguay">Uruguay</option>
                                    <option value="Guyana">Guyana</option>
                                    <option value="Suriname">Suriname</option>
                                    <option value="French Guiana">French Guiana</option>
                                    <option value="Other">Other</option>
                                </select>
                            </p>
                        </div>
                    </div>
                    <p class="smallText">
                        Website:
                        <input class="form-control" type="url" v-model="contactForm.website" placeholder="https://example.com" />
                    </p>
                </div>
            </div>
            <template #footer>
                <div class="container">
                    <div class="row">
                        <div class="col-6 d-flex align-items-center justify-content-center">
                            <vs-button @click="saveContact()" transparent>
                                {{ isEditing ? 'Update' : 'Create' }} Contact
                            </vs-button>
                        </div>
                        <div class="col-6 d-flex align-items-center justify-content-center">
                            <vs-button @click="closeModal()" danger transparent>
                                Cancel
                            </vs-button>
                        </div>
                    </div>
                </div>
            </template>
        </vs-dialog>

                 <!-- Modal para adjuntar farm -->
         <vs-dialog not-center v-model="modalAttachFarm">
             <template #header>
                 <h4 class="not-margin">Attach <b>Farm</b></h4>
             </template>
             <div class="con-content">
                 <p>Select a farm and role to attach to contact <strong>{{ selectedContact.contact_name }}</strong></p>
                 <div class="form-group">
                     <p class="smallText">
                         Farm: <span class="text-danger">*</span>
                         <select class="form-control" v-model="selectedFarmId">
                             <option value="">Select a farm...</option>
                             <option v-for="farm in farms" :key="farm.id" :value="farm.id">
                                 {{ farm.name }}
                             </option>
                         </select>
                     </p>
                     <p class="smallText">
                         Role: <span class="text-danger">*</span>
                         <select class="form-control" v-model="selectedRoleType">
                             <option value="">Select a role...</option>
                             <option value="manager">Manager</option>
                             <option value="supervisor">Supervisor</option>
                             <option value="safety_officer">Safety Officer</option>
                             <option value="owner">Owner</option>
                             <option value="emergency">Emergency Contact</option>
                         </select>
                     </p>
                 </div>
             </div>
             <template #footer>
                 <div class="container">
                     <div class="row">
                         <div class="col-6 d-flex align-items-center justify-content-center">
                             <vs-button @click="attachFarm()" transparent> Attach Farm </vs-button>
                         </div>
                         <div class="col-6 d-flex align-items-center justify-content-center">
                             <vs-button @click="closeAttachFarmModal()" danger transparent>
                                 Cancel
                             </vs-button>
                         </div>
                     </div>
                 </div>
             </template>
         </vs-dialog>

         <!-- Modal de confirmación para eliminar relación farm-contact -->
         <vs-dialog not-center v-model="modalDeleteFarmContact">
             <template #header>
                 <h4 class="not-margin">Remove <b>Farm Assignment</b></h4>
             </template>
             <div class="con-content">
                 <p>¿Are you sure you want to remove <strong>{{ selectedFarmContact.contact_name }}</strong> from <strong>{{ selectedFarmContact.farm_name }}</strong>?</p>
                 <p class="text-muted">This action cannot be undone.</p>
             </div>
             <template #footer>
                 <div class="container">
                     <div class="row">
                         <div class="col-6 d-flex align-items-center justify-content-center">
                             <vs-button @click="confirmDeleteFarmContact()" transparent> Yes! </vs-button>
                         </div>
                         <div class="col-6 d-flex align-items-center justify-content-center">
                             <vs-button @click="modalDeleteFarmContact = false" danger transparent>
                                 Cancel
                             </vs-button>
                         </div>
                     </div>
                 </div>
             </template>
         </vs-dialog>
         
         <!-- Modal de confirmación para eliminar -->
         <vs-dialog not-center v-model="modalDelete">
            <template #header>
                <h4 class="not-margin">Delete <b>contact</b></h4>
            </template>
            <div class="con-content">
                <p>¿Are you sure you want to delete contact {{ selectedContact.contact_name }}?</p>
                <p class="text-muted">This action cannot be undone.</p>
            </div>
            <template #footer>
                <div class="container">
                    <div class="row">
                        <div class="col-6 d-flex align-items-center justify-content-center">
                            <vs-button @click="deleteContact()" transparent> Yes! </vs-button>
                        </div>
                        <div class="col-6 d-flex align-items-center justify-content-center">
                            <vs-button @click="modalDelete = false" danger transparent>
                                Cancel
                            </vs-button>
                        </div>
                    </div>
                </div>
            </template>
        </vs-dialog>

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h3>📇 Address Book</h3>
                    <p class="smallText">
                        Manage contact information for your farms and stations. You can create, edit, and organize your contacts.
                    </p>
                </div>
                
                <!-- Formulario para crear nuevo contacto -->
                <div class="col-md-12">
                    <div class="card main-card">
                        <div class="card-body">
                                                         <h4>Add New Contact</h4>
                             <p class="text-muted small mb-3">
                                 <span class="text-danger">*</span> Required fields
                             </p>
                             <div class="form-group">
                                                                 <p class="smallText">
                                     Contact Name <span class="text-danger">*</span>
                                     <input type="text" class="form-control mt-2" placeholder="John Doe" v-model.trim="newContact.contact_name" />
                                 </p>
                                 <p class="smallText">
                                     Phone <span class="text-danger">*</span>
                                     <input type="tel" class="form-control mt-2" v-mask="'###-###-####'" placeholder="555-123-4567" v-model.trim="newContact.phone" />
                                 </p>
                                <p class="smallText">
                                    Email
                                    <input type="email" class="form-control mt-2" placeholder="john@example.com" v-model.trim="newContact.email" />
                                </p>
                                <p class="smallText">
                                    Street Address
                                    <input type="text" class="form-control mt-2" placeholder="123 Main St" v-model.trim="newContact.street" />
                                </p>
                                <div class="row">
                                    <div class="col-md-3">
                                        <p class="smallText">
                                            City
                                            <input type="text" class="form-control mt-2" placeholder="New York" v-model.trim="newContact.city" />
                                        </p>
                                    </div>
                                                                         <div class="col-md-3">
                                         <p class="smallText">
                                             State
                                             <select class="form-control mt-2" v-model="newContact.state" :disabled="newContact.country !== 'United States'">
                                                 <option value="">Select State</option>
                                                 <option v-for="state in usStates" :key="state.code" :value="state.code">
                                                     {{ state.code }} - {{ state.name }}
                                                 </option>
                                             </select>
                                         </p>
                                     </div>
                                    <div class="col-md-3">
                                        <p class="smallText">
                                            ZIP Code
                                            <input type="text" class="form-control mt-2" placeholder="10001" v-model.trim="newContact.zip_code" />
                                        </p>
                                    </div>
                                    <div class="col-md-3">
                                        <p class="smallText">
                                            Country
                                            <select class="form-control mt-2" v-model="newContact.country">
                                                <option value="United States">United States</option>
                                                <option value="Canada">Canada</option>
                                                <option value="Mexico">Mexico</option>
                                                <option value="United Kingdom">United Kingdom</option>
                                                <option value="Germany">Germany</option>
                                                <option value="France">France</option>
                                                <option value="Spain">Spain</option>
                                                <option value="Italy">Italy</option>
                                                <option value="Australia">Australia</option>
                                                <option value="Brazil">Brazil</option>
                                                <option value="Argentina">Argentina</option>
                                                <option value="Chile">Chile</option>
                                                <option value="Colombia">Colombia</option>
                                                <option value="Peru">Peru</option>
                                                <option value="Venezuela">Venezuela</option>
                                                <option value="Ecuador">Ecuador</option>
                                                <option value="Bolivia">Bolivia</option>
                                                <option value="Paraguay">Paraguay</option>
                                                <option value="Uruguay">Uruguay</option>
                                                <option value="Guyana">Guyana</option>
                                                <option value="Suriname">Suriname</option>
                                                <option value="French Guiana">French Guiana</option>
                                                <option value="Other">Other</option>
                                            </select>
                                        </p>
                                    </div>
                                </div>
                                <p class="smallText">
                                    Website
                                    <input type="url" class="form-control mt-2" placeholder="https://example.com" v-model.trim="newContact.website" />
                                </p>
                            </div>
                            <div class="form-group mt-3">
                                <button class="btn btn-primary" @click="createContact()">Add Contact</button>
                                <button class="btn btn-secondary ms-2" @click="clearForm()">Clear Form</button>
                            </div>
                        </div>
                    </div>
                </div>

                                 <!-- Relaciones Farm-Contact -->
                 <div class="col-md-12">
                     <div class="card mt-5 mb-5">
                         <div class="card-body">
                             <h4>🏭 Farm Assignments</h4>
                             <p class="smallText">
                                 View and manage which farms are assigned to your contacts and their roles.
                             </p>
                             
                             <div v-if="farmContacts.length === 0" class="text-center py-4">
                                 <p class="text-muted">No farm assignments found. Use "Attach Farm" to create assignments.</p>
                             </div>
                             
                             <div v-else class="table-responsive">
                                 <table class="table table-striped">
                                     <thead>
                                         <tr>
                                             <th>Farm Name</th>
                                             <th>Contact Name</th>
                                             <th>Phone</th>
                                             <th>Email</th>
                                             <th>Role</th>
                                             <th>Assigned Date</th>
                                             <th>Actions</th>
                                         </tr>
                                     </thead>
                                     <tbody>
                                         <tr v-for="assignment in farmContacts" :key="assignment.relationship_id">
                                             <td>
                                                 <strong>{{ assignment.name }}</strong>
                                             </td>
                                             <td>{{ assignment.contact_name }}</td>
                                             <td>{{ assignment.phone }}</td>
                                             <td>{{ assignment.email || 'N/A' }}</td>
                                             <td>
                                                 <select class="form-control form-control-sm" 
                                                         v-model="assignment.role_type"
                                                         @change="updateFarmContactRole(assignment.relationship_id, assignment.role_type)">
                                                     <option value="manager">Manager</option>
                                                     <option value="supervisor">Supervisor</option>
                                                     <option value="safety_officer">Safety Officer</option>
                                                     <option value="owner">Owner</option>
                                                     <option value="emergency">Emergency Contact</option>
                                                 </select>
                                             </td>
                                             <td>{{ new Date(assignment.relationship_created).toLocaleDateString() }}</td>
                                             <td>
                                                   <a class="text-link smallText" @click="deleteFarmContactModal(assignment)">
                                                    <span class="material-icons smallText me-1">delete</span>Delete
                                                </a>
                                             </td>
                                         </tr>
                                     </tbody>
                                 </table>
                             </div>
                         </div>
                     </div>
                 </div>
                 
                 <!-- Tabla de contactos -->
                 <div class="col-md-12">
                     <div class="card mt-5 mb-5 ">
                         <div class="card-body">
                             <h4>Contact List</h4>
                            
                            <!-- Filtros -->
                            <div class="row mb-3 mt-3 ">
                                <div class="col-md-12">
                                    <p class="fw-bold">Filter</p>
                                </div>
                                <div class="col-md-4">
                                    <label>Search by Name</label>
                                    <input type="text" class="form-control" v-model="searchName" placeholder="Search by contact name..." />
                                </div>
                                <div class="col-md-4">
                                    <label>Search by Phone</label>
                                    <input type="text" class="form-control" v-model="searchPhone" v-mask="'###-###-####'" placeholder="Search by phone..." />
                                </div>
                                <div class="col-md-4">
                                    <label>Search by Email</label>
                                    <input type="text" class="form-control" v-model="searchEmail" placeholder="Search by email..." />
                                </div>
                                <div class="col-md-12 text-center mt-3">
                                    <p class="serial-number" @click="clearFilters()">🔄 Reset filters</p>
                                </div>
                            </div>

                            <!-- Paginación superior -->
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <p>Total contacts: {{ totalContacts }}</p>
                                </div>
                                <div>
                                    <p>Pages: {{ totalPages }}</p>
                                </div>
                            </div>

                            <vs-table>
                                <template #header>
                                    <vs-input v-model="search" border placeholder="Search contacts..." />
                                </template>
                                <template #thead>
                                    <vs-tr>
                                        <vs-th sort @click="contacts = $vs.sortData($event, contacts, 'contact_name')">Contact Name</vs-th>
                                        <vs-th sort @click="contacts = $vs.sortData($event, contacts, 'phone')">Phone</vs-th>
                                        <vs-th sort @click="contacts = $vs.sortData($event, contacts, 'email')">Email</vs-th>
                                        <vs-th sort @click="contacts = $vs.sortData($event, contacts, 'city')">City</vs-th>
                                        <vs-th>Status</vs-th>
                                        <vs-th style="width: 150px;">Actions</vs-th>
                                    </vs-tr>
                                </template>
                                <template #tbody>
                                    <vs-tr :key="i" v-for="(contact, i) in $vs.getSearch(filteredContacts, search)" :data="contact">
                                                                                 <vs-td>
                                             <strong class="text-main-gradient-secondary">{{ contact.contact_name }}</strong>
                                         </vs-td>
                                        <vs-td>
                                            {{ contact.phone }}
                                        </vs-td>
                                        <vs-td>
                                            {{ contact.email || 'N/A' }}
                                        </vs-td>
                                        <vs-td>
                                            {{ contact.city || 'N/A' }}, {{ contact.state || 'N/A' }}
                                        </vs-td>
                                        <vs-td>
                                            <template v-if="contact.is_active == 1">
                                                <span class="badge bg-success">Active</span>
                                            </template>
                                            <template v-else>
                                                <span class="badge bg-secondary">Inactive</span>
                                            </template>
                                        </vs-td>
                                                                                 <vs-td>
                                             <a class="text-link smallText" @click="attachFarmModal(contact)">
                                                 <span class="material-icons smallText me-1">agriculture</span>Attach Farm
                                             </a>
                                             <br />
                                             <a class="text-link smallText" @click="editContactModal(contact)">
                                                 <span class="material-icons smallText me-1">edit</span>Edit
                                             </a>
                                             <br />
                                            <a class="text-link smallText" @click="toggleContactStatus(contact)">
                                                <span class="material-icons smallText me-1">{{ contact.is_active == 1 ? 'block' : 'check_circle' }}</span>
                                                {{ contact.is_active == 1 ? 'Deactivate' : 'Activate' }}
                                            </a>
                                            <br />
                                            <a class="text-link smallText" @click="deleteContactModal(contact)">
                                                <span class="material-icons smallText me-1">delete</span>Delete
                                            </a>
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>

                            <!-- Paginación inferior -->
                            <div class="d-flex justify-content-center mt-3">
                                <v-pagination v-model.number="currentPage" :page-count="totalPages" @input="fetchContacts" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var config = require("@/config/api.json");
const API = config.api;
import axios from "axios";
import vPagination from 'vue-plain-pagination';
import usStatesData from '@/config/states.json';

export default {
    name: "UserContactInformation",
    components: {
        vPagination
    },
    props: {
        userId: {
            type: [String, Number],
            required: true
        },
        uid: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            // Datos de contactos
            contacts: [],
            totalContacts: 0,
            totalPages: 1,
            currentPage: 1,
            
            // Filtros
            search: "",
            searchName: "",
            searchPhone: "",
            searchEmail: "",
            
                         // Modales
             modalContact: false,
             modalDelete: false,
             modalAttachFarm: false,
             modalDeleteFarmContact: false,
             isEditing: false,
            
            // Formularios
            newContact: {
                contact_name: "",
                phone: "",
                email: "",
                street: "",
                city: "",
                state: "",
                zip_code: "",
                country: "United States",
                website: ""
            },
            contactForm: {
                id: null,
                farm_id: null,
                contact_name: "",
                phone: "",
                email: "",
                street: "",
                city: "",
                state: "",
                zip_code: "",
                country: "United States",
                website: ""
            },
            
                         // Contacto seleccionado
             selectedContact: {},
             
             // Farm contact seleccionado para eliminar
             selectedFarmContact: {},
            
                         // Usuario actual
             user: null,
             
             // Estados de Estados Unidos
             usStates: usStatesData,
             
             // Farms del usuario
             farms: [],
             
             // Farm seleccionada para adjuntar
             selectedFarmId: null,
             
             // Rol seleccionado para adjuntar
             selectedRoleType: null,
             
             // Relaciones farm-contact existentes
             farmContacts: []
        };
    },
    
    computed: {
        filteredContacts() {
            let filtered = this.contacts;
            
            if (this.searchName) {
                filtered = filtered.filter(contact => 
                    contact.contact_name.toLowerCase().includes(this.searchName.toLowerCase())
                );
            }
            
            if (this.searchPhone) {
                filtered = filtered.filter(contact => 
                    contact.phone.includes(this.searchPhone)
                );
            }
            
            if (this.searchEmail) {
                filtered = filtered.filter(contact => 
                    contact.email && contact.email.toLowerCase().includes(this.searchEmail.toLowerCase())
                );
            }
            
            return filtered;
        }
    },
    
    async mounted() {
        // Obtener usuario actual
        try {
            const { auth } = await import("@/fb");
            const user = auth.currentUser;
            if (user) {
                this.user = user;
            } else {
                const { onAuthStateChanged } = await import("firebase/auth");
                await new Promise((resolve) => {
                    onAuthStateChanged(auth, (u) => {
                        if (u) {
                            this.user = u;
                            resolve();
                        }
                    });
                });
            }
        } catch (e) {
            this.user = null;
        }
        
                     // Cargar contactos, farms y farm contacts
             await this.fetchContacts(1);
             await this.getUserFarms();
             await this.loadFarmContacts();
             
             // Agregar watchers para limpiar el campo state cuando cambie el país
             this.$watch('newContact.country', this.handleCountryChange);
             this.$watch('contactForm.country', this.handleCountryChange);
    },
    
    methods: {
        async fetchContacts(page = 1) {
            this.openLoading();
            console.log('user id', this.userId);
            try {
                // Obtener contactos directamente por user_id
                const contactsResponse = await axios.get(`${API}/contact-info/user/${this.userId}`);
                if (contactsResponse.data && contactsResponse.data.success) {
                    this.contacts = contactsResponse.data.data;
                    this.totalContacts = this.contacts.length;
                    this.totalPages = Math.ceil(this.totalContacts / 10);
                    this.currentPage = page;
                } else {
                    this.contacts = [];
                    this.totalContacts = 0;
                    this.totalPages = 1;
                }
            } catch (error) {
                console.error("Error fetching contacts:", error);
                this.notify("error", "Error loading contacts");
                this.contacts = [];
            } finally {
                this.closeLoading();
            }
        },
        
        async createContact() {
            if (!this.vEmpty(this.newContact.contact_name, "Contact Name")) {
                return;
            }
            if (!this.vEmpty(this.newContact.phone, "Phone")) {
                return;
            }
            
            this.openLoading();
            try {
                const payload = {
                    user_id: this.userId,
                    contact_name: this.newContact.contact_name,
                    phone: this.newContact.phone,
                    email: this.newContact.email || null,
                    street: this.newContact.street || null,
                    city: this.newContact.city || null,
                    state: this.newContact.state || null,
                    zip_code: this.newContact.zip_code || null,
                    country: this.newContact.country,
                    website: this.newContact.website || null
                };
                
                const response = await axios.post(`${API}/contact-info/`, payload);
                
                                 if (response.data && response.data.success) {
                     this.notify("success", "Contact created successfully");
                     this.callLog(this.user.email, 'create', 'contacts', `Created contact ${this.newContact.contact_name}`);
                     this.clearForm();
                     this.closeLoading();
                     await this.fetchContacts(1);
                     await this.loadFarmContacts();
                 }
            } catch (error) {
                console.error("Error creating contact:", error);
                this.notify("error", error.response?.data?.error || "Error creating contact");
            } finally {
                this.closeLoading();
            }
        },
        
        editContactModal(contact) {
            this.isEditing = true;
            this.selectedContact = contact;
            this.contactForm = {
                id: contact.id,
                user_id: contact.user_id,
                contact_name: contact.contact_name,
                phone: contact.phone,
                email: contact.email || "",
                street: contact.street || "",
                city: contact.city || "",
                state: contact.state || "",
                zip_code: contact.zip_code || "",
                country: contact.country || "United States",
                website: contact.website || ""
            };
            this.modalContact = true;
        },
        
        async saveContact() {
            if (!this.vEmpty(this.contactForm.contact_name, "Contact Name")) {
                return;
            }
            if (!this.vEmpty(this.contactForm.phone, "Phone")) {
                return;
            }
            
            this.openLoading();
            try {
                const payload = {
                    user_id: this.contactForm.user_id,
                    contact_name: this.contactForm.contact_name,
                    phone: this.contactForm.phone,
                    email: this.contactForm.email || null,
                    street: this.contactForm.street || null,
                    city: this.contactForm.city || null,
                    state: this.contactForm.state || null,
                    zip_code: this.contactForm.zip_code || null,
                    country: this.contactForm.country,
                    website: this.contactForm.website || null
                };
                
                const response = await axios.put(`${API}/contact-info/${this.contactForm.id}`, payload);
                
                                 if (response.data && response.data.success) {
                     this.notify("success", "Contact updated successfully");
                     this.callLog(this.user.email, 'update', 'contacts', `Updated contact ${this.contactForm.contact_name}`);
                     this.closeModal();
                     this.closeLoading();
                     await this.fetchContacts(1);
                     await this.loadFarmContacts();
                 }
            } catch (error) {
                console.error("Error updating contact:", error);
                this.notify("error", error.response?.data?.error || "Error updating contact");
            } finally {
                this.closeLoading();
            }
        },
        
        deleteContactModal(contact) {
            this.selectedContact = contact;
            this.modalDelete = true;
        },
        
                 async deleteContact() {
             this.openLoading();
             try {
                 const response = await axios.delete(`${API}/contact-info/${this.selectedContact.id}`);
                 
                 if (response.data && response.data.success) {
                     this.notify("success", "Contact deleted successfully");
                     this.callLog(this.user.email, 'delete', 'contacts', `Deleted contact ${this.selectedContact.contact_name}`);
                     this.modalDelete = false;
                     this.selectedContact = {};
                     this.closeLoading();
                     await this.fetchContacts(1);
                     await this.loadFarmContacts();
                 }
             } catch (error) {
                 console.error("Error deleting contact:", error);
                 this.notify("error", error.response?.data?.error || "Error deleting contact");
             } finally {
                 this.closeLoading();
             }
         },
        
                 async toggleContactStatus(contact) {
             this.openLoading();
             try {
                 const newStatus = contact.is_active === 1 ? 0 : 1;
                 const response = await axios.patch(`${API}/contact-info/${contact.id}/status`, {
                     is_active: newStatus
                 });
                 
                 if (response.data && response.data.success) {
                     this.notify("success", `Contact ${newStatus === 1 ? 'activated' : 'deactivated'} successfully`);
                     this.callLog(this.user.email, 'update', 'contacts', `${newStatus === 1 ? 'Activated' : 'Deactivated'} contact ${contact.contact_name}`);
                     this.closeLoading();
                     await this.fetchContacts(1);
                     await this.loadFarmContacts();
                 }
             } catch (error) {
                 console.error("Error toggling contact status:", error);
                 this.notify("error", error.response?.data?.error || "Error updating contact status");
             } finally {
                 this.closeLoading();
             }
         },
        
        closeModal() {
            this.modalContact = false;
            this.isEditing = false;
            this.selectedContact = {};
            this.contactForm = {
                id: null,
                user_id: null,
                contact_name: "",
                phone: "",
                email: "",
                street: "",
                city: "",
                state: "",
                zip_code: "",
                country: "United States",
                website: ""
            };
        },
        
        clearForm() {
            this.newContact = {
                contact_name: "",
                phone: "",
                email: "",
                street: "",
                city: "",
                state: "",
                zip_code: "",
                country: "United States",
                website: ""
            };
        },
        
                 clearFilters() {
             this.search = "";
             this.searchName = "";
             this.searchPhone = "";
             this.searchEmail = "";
         },
         
         handleCountryChange(newCountry) {
             // Si el país cambia a algo diferente a Estados Unidos, limpiar el campo state
             if (newCountry !== 'United States') {
                 if (this.isEditing) {
                     this.contactForm.state = "";
                 } else {
                     this.newContact.state = "";
                 }
             }
         },
         
         async getUserFarms() {
             this.farms = [];
             console.log(`${API}/getFarmsByOwner/${this.userId}`);
             try {
                 const response = await axios.get(
                     `${API}/getFarmsByOwner/${this.userId}`
                 );
                 this.farms = response.data;
                 console.log("FARMS");
                 console.log(response.data);
             } catch (error) {
                 console.error("Error", error);
                 this.notify("error", "Failed to fetch farms");
             }
         },
         
         attachFarmModal(contact) {
             this.selectedContact = contact;
             this.selectedFarmId = null;
             this.selectedRoleType = null;
             this.modalAttachFarm = true;
             this.loadFarmContacts();
         },
         
         async attachFarm() {
             if (!this.selectedFarmId) {
                 this.notify("error", "Please select a farm");
                 return;
             }
             
             if (!this.selectedRoleType) {
                 this.notify("error", "Please select a role");
                 return;
             }
             
             this.openLoading();
             try {
                 const payload = {
                     farm_id: this.selectedFarmId,
                     user_id: this.userId,
                     contact_id: this.selectedContact.id,
                     role_type: this.selectedRoleType
                 };
                 
                 const response = await axios.post(`${API}/farm-contacts/`, payload);
                 console.log(response.data);
                 
                 if (response.data && response.data.success) {
                     this.notify("success", "Farm attached successfully");
                     this.callLog(this.user.email, 'create', 'farm-contacts', `Attached farm to contact ${this.selectedContact.contact_name}`);
                     this.closeAttachFarmModal();
                     await this.loadFarmContacts();
                 }
             } catch (error) {
                 console.error("Error attaching farm:", error);
                 this.notify("error", error.response?.data?.error || "Error attaching farm");
             } finally {
                 this.closeLoading();
             }
         },
         
         async loadFarmContacts() {
             try {
                 const response = await axios.get(`${API}/farm-contacts/user/${this.userId}`);
                 if (response.data && response.data.success) {
                     this.farmContacts = response.data.data;
                 } else {
                     this.farmContacts = [];
                 }
             } catch (error) {
                 console.error("Error loading farm contacts:", error);
                 this.farmContacts = [];
             }
         },
         
         closeAttachFarmModal() {
             this.modalAttachFarm = false;
             this.selectedFarmId = null;
             this.selectedRoleType = null;
             this.selectedContact = {};
         },
         
         async updateFarmContactRole(relationshipId, newRole) {
             this.openLoading();
             try {
                 const response = await axios.put(`${API}/farm-contacts/${relationshipId}`, {
                     role_type: newRole
                 });
                 
                 if (response.data && response.data.success) {
                     this.notify("success", "Role updated successfully");
                     this.callLog(this.user.email, 'update', 'farm-contacts', `Updated role to ${newRole}`);
                     await this.loadFarmContacts();
                 }
             } catch (error) {
                 console.error("Error updating role:", error);
                 this.notify("error", error.response?.data?.error || "Error updating role");
             } finally {
                 this.closeLoading();
             }
         },
         
         deleteFarmContactModal(assignment) {
             this.selectedFarmContact = {
                 relationship_id: assignment.relationship_id,
                 contact_name: assignment.contact_name,
                 farm_name: assignment.name
             };
             this.modalDeleteFarmContact = true;
         },
         
         async confirmDeleteFarmContact() {
             this.openLoading();
             try {
                 const response = await axios.delete(`${API}/farm-contacts/${this.selectedFarmContact.relationship_id}`);
                 
                 if (response.data && response.data.success) {
                     this.notify("success", "Farm contact removed successfully");
                     this.callLog(this.user.email, 'delete', 'farm-contacts', `Removed ${this.selectedFarmContact.contact_name} from ${this.selectedFarmContact.farm_name}`);
                     this.modalDeleteFarmContact = false;
                     this.selectedFarmContact = {};
                     await this.loadFarmContacts();
                 }
             } catch (error) {
                 console.error("Error deleting farm contact:", error);
                 this.notify("error", error.response?.data?.error || "Error removing farm contact");
             } finally {
                 this.closeLoading();
             }
         }
    }
};
</script>

<style scoped>
.filter-row {
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.serial-number {
    color: #007bff;
    cursor: pointer;
    text-decoration: underline;
}

.serial-number:hover {
    color: #0056b3;
}

.badge {
    font-size: 0.75rem;
}

.material-icons {
    font-size: 1rem;
    vertical-align: middle;
}

.text-main-gradient-secondary {
    background: linear-gradient(45deg, #007bff, #0056b3);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: bold;
}

@media (max-width: 768px) {
    .actions-col {
        white-space: normal;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: flex-start;
    }
}
</style>